export const sectionReveal = (() => {
  let observer;

  const initObserver = () => {
    if (observer) return observer;
    observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    return observer;
  };

  const reveal = (elements) => {
    if (!elements || !elements.length) return;
    const obs = initObserver();
    elements.forEach((el) => {
      if (!el.classList.contains('sr-ready')) {
        el.classList.add('sr-ready');
      }
      obs.observe(el);
    });
  };

  return { reveal };
})();
